module.exports = __webpack_public_path__ + "img/bg-minha-conta.05e2049d.png";